import React from "react";
import scrollTo from "gatsby-plugin-smoothscroll";
import { Link } from "gatsby";

export const Footer = () => {
  return (
    <footer className="h-[520px] md:h-[200px] lg:h-auto w-full relative shadow bg-sandLight dark:bg-gray-900">
      <div className="w-full max-w-screen-xl p-4 mx-auto lg:pt-[32px]">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-0">
          <ul className="flex flex-col flex-wrap items-start gap-2 pl-4 mb-6 sm:flex-row sm:items-center sm:pl-12 sm:mb-0 text-brownDark dark:text-gray-400 sm:gap-0">
            <li className="pb-0 mb-0">
              <Link to="/about" className="mr-4 md:mr-6">About</Link>
            </li>
            <li className="pb-0 mb-0">
              <button
                onClick={() => scrollTo("#services-bubble")}
                className="mr-4 text-left md:mr-6"
              >
                Services
              </button>
            </li>
            <li className="pb-0 mb-0">
              <Link to="/terms-and-conditions" className="mr-4 md:mr-6">Terms & Conditions</Link>
            </li>
            <li className="pb-0 mb-0">
              <button
                onClick={() => scrollTo("#contact-form")}
                className="text-left"
              >
                Contact
              </button>
            </li>
          </ul>
          <span className="block text-sm text-center text-slate-500 sm:text-left sm:text-sm">
            © {new Date().getFullYear()}{" "}
            <Link to="/" className="ml-1">Health And Bloom</Link>. All Rights Reserved. <span>🌸</span>
          </span>
        </div>
        <hr className="pb-8 lg:pb-[64px] my-2 border-brownDark border-1 sm:mx-auto" />
      </div>
    </footer>
  );
};
